/* eslint no-use-before-define: ["error", { "functions": false }] */
const INITIAL_STATE = {
  trainingRoutineId: 0,
};

const strategies = {
  '@training-routine/COPY_TRAINING_ROUTINE': copyTrainingRoutine,
  __default__: (state) => state,
};

export default function copy(state = INITIAL_STATE, action) {
  const transformer = strategies[action.type] || strategies.__default__;
  return transformer(state, action);
}

function copyTrainingRoutine(state, action) {
  return { ...state, trainingRoutineId: action.payload.id };
}
